module.exports = __webpack_public_path__ + "img/natudrin-depoimento-6.9eaa4027.jpg";